import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
    Button,
    ModalNext,
    ModalHeader,
    ModalBody,
    ModalFooter
} from '@jutro/components';

function NonBlockingMsgPopup(props) {
    const {
        title,
        actionBtnLabel,
        isOpen,
        onResolve,
        nonBlockingMessage
    } = props;

    const handleNext = useCallback(() => {
        onResolve();
    }, [onResolve]);

    return (
        <ModalNext isOpen={isOpen}>
            <ModalHeader title={title} />
            <ModalBody
                contentLayout={{
                    component: 'grid'
                }}
            >
               { nonBlockingMessage.map((message,index) => {
                  return( <div key={index}>{message.description}</div>)
                }) }       
            </ModalBody>
            <ModalFooter>
                <Button onClick={handleNext}>
                    {actionBtnLabel}
                </Button>
            </ModalFooter>
        </ModalNext>
    );
}

NonBlockingMsgPopup.propTypes = {
    title: PropTypes.string.isRequired,
    actionBtnLabel: PropTypes.shape({}).isRequired,
    onResolve: PropTypes.func,
    isOpen: PropTypes.bool,
    nonBlockingMessage: PropTypes.array.isRequired
};

export default NonBlockingMsgPopup;
